<ion-split-pane
  contentId="main-content"
  [class.layout-assessment]="layoutMode === 'assessment'"
  [class.layout-hide-main-menu]="hideMainMenu"
>
  @if (!hideMainMenu) {
    <ion-menu contentId="main-content" menuId="main-menu">
      <ion-header class="ion-no-border">
        <ion-toolbar>
          <ion-title>Menu</ion-title>
        </ion-toolbar>
      </ion-header>

      <ion-content>
        @if (user$ | async; as user) {
          <ion-list id="avatar">
            <ion-item lines="none">
              <ion-avatar slot="start" aria-hidden="true">
                <img
                  [alt]="user.first_name + ' ' + user.last_name"
                  [src]="user.photo"
                />
              </ion-avatar>
              <ion-label>
                <h2>{{ user.first_name }} {{ user.last_name }}</h2>
                <p>{{ user.email }}</p>
              </ion-label>
            </ion-item>
          </ion-list>
        }

        <app-main-menu></app-main-menu>
      </ion-content>
    </ion-menu>
  }

  <ion-router-outlet id="main-content"></ion-router-outlet>

</ion-split-pane>

<!-- Keep the floating tab outside the split-pane layout. -->
@if (impersonation$ | async; as imp) {
  <div class="imp-tab" [class.is-open]="impTabOpen" [style.--imp-tab-position]="impTabY === null ? null : impTabY + 'px'">
    <button
      type="button"
      class="imp-tab__toggle"
      (click)="toggleImpTab($event)"
      (pointerdown)="startImpTabDrag($event)"
      (pointermove)="moveImpTabDrag($event)"
      (pointerup)="endImpTabDrag($event)"
      (pointercancel)="endImpTabDrag($event)"
      (lostpointercapture)="endImpTabDrag($event)"
      aria-label="Toggle impersonation panel; drag vertically to reposition"
    >
      <ion-icon name="eye-off-outline"></ion-icon>
    </button>

    <div class="imp-tab__panel" role="status" aria-live="polite">
      <div class="imp-tab__header">
        <div class="imp-tab__title">
          <ion-icon name="eye-off-outline"></ion-icon>
          <span>Impersonating</span>
        </div>

        <button type="button" class="imp-tab__close" (click)="closeImpTab()" aria-label="Close">
          ✕
        </button>
      </div>

      <div class="imp-tab__body">
        <div class="imp-tab__name">
          {{ imp.targetUserName }}
        </div>

        <div class="imp-tab__note">
          Be careful: some actions can trigger emails, mark items read, or write data as the impersonated user.
        </div>

        <div class="imp-tab__disabled">
          <strong>Limited while impersonating:</strong>
          <ul>
            <li>Forums (posting/commenting disabled)</li>
            <li>Actions that notify users may be blocked</li>
          </ul>
        </div>
      </div>

      <div class="imp-tab__footer">
        To revert, sign out.
      </div>
    </div>
  </div>
}
